<template>
  <div id="charts6"></div>
</template>
<script>
import echarts from "echarts";
export default {
  mounted() {
    this.initCharts();
  },
  methods: {
    initCharts() {
      const charts6 = echarts.init(document.getElementById("charts6"));
      // 科目
      var subjects = ["需求分析", "需求文档", "代码实现", "数据库设计", "功能测试"];
      // 成绩
      var grade = [85, 130, 90, 30, 90];
      // 颜色
      var color = ['#f4f4f4', '#c2f2df', '#03b187', '#4ad99e', '#86e6bf'];
      const option = {
        backgroundColor: "#ffffff",
        grid: {
          containLabel: true,
          top: "10%",
          left: "-10%",
          bottom: "0",
          right: '0'
        },
        xAxis: {
          // name: "科目",
          axisLabel: {
            interval:0,
            rotate:0,
            textStyle: {
              fontSize: 10
            }
          },
          data: subjects,
          axisLine:{
            show: false
          },
          axisTick:{
            show: false
          },
        },
        yAxis: {
          // name: "成绩",
          splitLine: { show: false },
          axisLine:{
            show: false
          },
          axisTick:{
            show: false
          },
        },
        series: [
          {
            type: "bar",
            barWidth: "40%",
            label: {
              normal: {
                show: true,
                position: "top",
                textStyle: {
                  color: '#969696',
                  fontSize: 12
                },
                rich: {}
              },
              // emphasis: {
              //   formatter: '覆盖率：{c}%',
              //   textStyle: {
              //     color: '#969696'
              //   }
              // }
            },
            itemStyle: {
              normal: {
                color: function(param) {
                  return color[param.dataIndex];
                },
                barBorderRadius: [5, 5, 0, 0],
                shadowColor: "#BABABA",
                shadowBlur: 5
              }
            },
            data: grade,
          }
        ]
      }

      charts6.setOption(option);
    }
  }
};
</script>
<style lang="scss" scoped>
#charts6 {
  width: 100%;
  height: 350px;
}
</style>